export default __webpack_public_path__ + "static/media/diagram3.9a51796d.png";